import React from "react";
import { Path, Svg } from "react-native-svg";
import { styleConstants } from "~/style/styleConstants";

export const Logo = ({
  size = 24,
  backgroundColor = styleConstants.colorBackgroundTheme,
  strokeColor = styleConstants.colorBackgroundWhite,
}: {
  size?: number;
  backgroundColor?: string;
  strokeColor?: string;
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 1024 1024" fill="none">
      <Path
        d="M1024 512C1024 794.77 794.77 1024 512 1024C229.23 1024 0 794.77 0 512C0 229.23 229.23 0 512 0C794.77 0 1024 229.23 1024 512Z"
        fill={backgroundColor}
      />
      <Path
        d="M273.702 743.848C269.192 743.778 264.744 742.895 260.622 741.252C256.501 739.61 252.791 737.241 249.714 734.286C246.637 731.332 244.255 727.853 242.71 724.056C241.166 720.259 240.491 716.223 240.725 712.188C244.204 651.454 253.457 521.169 254.639 501.974C259.962 423.167 254.639 357.011 314.61 299.425C434.899 183.599 650.154 268.264 649.875 402.445C771.626 404.75 859.181 567.132 780.983 666.786C697.497 773.17 553.032 750.049 419.872 745.748C415.461 745.608 411.125 744.69 407.11 743.048C403.095 741.405 399.481 739.071 396.473 736.177C393.466 733.283 391.124 729.887 389.582 726.183C388.04 722.479 387.328 718.538 387.486 714.587L388.947 679.281C389.265 671.418 393.007 663.978 399.372 658.556C405.737 653.133 414.219 650.159 423.002 650.27C464.745 650.862 532.926 654.477 550.214 654.446C597.766 654.446 652.31 663.794 686.331 626.619C700.809 611.032 708.294 591.178 707.329 570.92C706.365 550.662 697.02 531.45 681.113 517.025C647.301 485.489 590.948 491.722 542.179 491.722C542.179 437.033 564.268 383.903 503.671 349.096C455.701 321.55 385.399 343.674 369.537 393.252C358.127 428.713 359.101 523.88 355.24 566.197C350.926 612.939 347.448 665.57 346.404 715.055C346.222 723.041 342.506 730.636 336.074 736.17C329.643 741.704 321.021 744.723 312.105 744.564L273.702 743.848Z"
        fill={strokeColor}
      />
    </Svg>
  );
};
